import React, {useState} from "react";
import Dropdown from "components/dropdown";
import {AiOutlineUser} from "react-icons/ai";
import {BsBagPlus, BsThreeDots} from "react-icons/bs";
import {FiSettings} from "react-icons/fi";
import {AiOutlineShop} from "react-icons/ai";
import {TiLightbulb} from "react-icons/ti";
import {BsThreeDotsVertical} from "react-icons/bs";
import {Md2KPlus, MdAdd, MdAddBox, MdAddCircle, MdAddCircleOutline, MdPlusOne} from "react-icons/md";

const DataPointsCardView = ({data, onSelect, onClose}) => {

    const [open, setOpen] = useState(false);

    const [selectedItems, setSelectedItems] = useState([]);

    const handleItemClick = (item) => {
        const newSelectedItems = [...selectedItems];
        const index = newSelectedItems.indexOf(item.dpid);
        if (index > -1) {
            newSelectedItems.splice(index, 1); // Remove if already selected
        } else {
            newSelectedItems.push(item.dpid); // Add if not selected
        }
        setSelectedItems(newSelectedItems);
        onSelect(newSelectedItems); // Pass selected items to parent
    };
    return (
        <Dropdown
            button={
                <button
                    onClick={() => setOpen(!open)}
                    className="flex items-center text-sm text-gray-600 font-bold hover:cursor-pointer">
                    Add New Data Points &nbsp;
                    <MdAddCircleOutline className="h-6 w-6 text-[#004c86]" onClick={() => setOpen(!open)}/>
                </button>
            }
            animation={"origin-top-right transition-all duration-300 ease-in-out"}
            classNames="top-11 right-0 w-full"
            children={
                <div
                    className="h-full z-50 w-max rounded-xl bg-white py-3 px-4 text-sm shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:shadow-none">
                    {
                        /*data.map((dp) => (*/
                        <div className="dropdown-content overflow-y-auto max-h-40">
                            <ul>
                                {data.map((item) => (
                                    <li key={item.dpid} onClick={() => handleItemClick(item)}>
                                        <p className="text-gray-600 text-sm hover:text-black cursor-pointer font-bold hover:font-medium">
                                            <input
                                                type="radio"
                                                id={item.dpid}
                                                checked={selectedItems.includes(item.dpid)}
                                                onChange={() => handleItemClick(item)}
                                            />
                                            &nbsp; {item.name}
                                        </p>
                                        <p className="text-gray-600 text-sm hover:text-black cursor-pointer hover:font-medium">
                                           &nbsp;  &nbsp; &nbsp; DPID : {item.dpid} ({item.type})
                                        </p>
                                        <p>
                                            &nbsp;
                                        </p>
                                    </li>

                                ))}
                            </ul>
                        </div>
                        /* ))*/
                    }
                    {/*<p className="hover:text-black flex cursor-pointer items-center gap-2 text-gray-600 hover:font-medium">
            <span>
              <AiOutlineUser/>
            </span>
                        Panel 1
                    </p>*/}
                    {/*<p className="hover:text-black mt-2 flex cursor-pointer items-center gap-2 pt-1 text-gray-600 hover:font-medium">
            <span>
              <AiOutlineShop />
            </span>
                Panel 2
              </p>
              <p className="hover:text-black mt-2 flex cursor-pointer items-center gap-2 pt-1 text-gray-600 hover:font-medium">
            <span>
              <TiLightbulb />
            </span>
                Panel 3
              </p>
              <p className="hover:text-black mt-2 flex cursor-pointer items-center gap-2 pt-1 text-gray-600 hover:font-medium">
            <span>
              <FiSettings />
            </span>
                Panel 4
              </p>*/}
                </div>
            }
        />
    );
}

export default DataPointsCardView;
